// Widget-Plugin: Background
vcDashboardRegistry.register("background", {
    noTitle: true,
    defaults: { w: 4, h: 4, resizable: true, copyable: false, showSettings: false },
    render: function ($container, item) {
        var html;
        if (item.svgIcon && typeof vcFloorIcons !== "undefined") {
            var svgHtml = vcFloorIcons.get(item.svgIcon, "dashboard-background-svg-icon");
            html = "<div class='dashboard-background-wrapper'>" + svgHtml + "</div>";
        } else {
            var iconClass = item.icon || "fa-image";
            html = "<div class='dashboard-background-wrapper'>" +
                "<i class='fa-solid " + iconClass + " dashboard-background-icon'></i>" +
            "</div>";
        }
        $container.html(html);
    },
    init: function ($item, settings) {
    }
});
